const schema = () => ({
  title: 'Embla Ratings',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['slides', 'slidesToShow', 'autoplay', 'autoplayDelay', 'alignment', 'verticalAlignment', 'isFullWidth', 'loop', 'hideArrows', 'hideDots'],
    },
  ],
  properties: {
    slides: {
      title: 'Reviews',
      widget: 'object_list',
      schema: {
        title: 'Review',
        titleField: 'author',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['rating', 'testimonial', 'author', 'company', 'image', 'link'],
          },
        ],
        properties: {
          rating: {
            title: 'Star rating (0 = no stars, 1–5 = rating)',
            type: 'number',
            minimum: 0,
            maximum: 5,
          },
          testimonial: {
            title: 'Testimonial',
            type: 'text',
          },
          author: {
            title: 'Author',
            type: 'string',
          },
          company: {
            title: 'Company',
            type: 'string',
          },
          image: {
            title: 'Image (headshot/logo)',
            widget: 'object_browser',
            mode: 'image',
            allowExternals: false,
          },
          link: {
            title: 'Link (makes entire slide clickable)',
            widget: 'object_browser',
            mode: 'link',
            allowExternals: true,
            multi: false,
          },
        },
        required: [],
      },
    },
    slidesToShow: {
      title: 'Slides to show',
      type: 'number',
      default: 1,
    },
    alignment: {
      title: 'Text alignment',
      widget: 'align',
      actions: ['left', 'center', 'right'],
      default: 'left',
    },
    verticalAlignment: {
      title: 'Vertical alignment',
      type: 'string',
      choices: [
        ['top', 'Top'],
        ['middle', 'Middle'],
        ['bottom', 'Bottom'],
      ],
      default: 'middle',
    },
    isFullWidth: {
      title: 'Full width carousel',
      type: 'boolean',
      default: false,
    },
    loop: {
      title: 'Loop infinitely',
      type: 'boolean',
      default: true,
    },
    autoplay: {
      title: 'Autoplay',
      type: 'boolean',
    },
    autoplayDelay: {
      title: 'Autoplay delay (ms)',
      type: 'number',
      default: 8000,
    },
    hideArrows: {
      title: 'Hide arrows',
      type: 'boolean',
    },
    hideDots: {
      title: 'Hide dots',
      type: 'boolean',
    },
  },
  required: [],
});

export default schema;